import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { InstallationDetailsStore, InstallationFeaturesStore } from '@store';
import { filter, map, switchMap } from 'rxjs/operators';
import { RoutingService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class SrcCommissioningGuard {
  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private installationDetailsStore: InstallationDetailsStore,
    private routingService: RoutingService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.installationDetailsStore.loaded$.pipe(
      filter((loaded) => loaded),
      switchMap(() => this.installationFeaturesStore.isSrcMenuItemVisible()),
      map((isVisible) => {
        if (!isVisible) {
          this.routingService.navigateToInstallationDashboardFromGuard(state);

          return false;
        }

        return true;
      })
    );
  }
}
